import React from "react";
import MatchGames from "./components/matchGames";
import TablePositionTeams from "./components/positionTeams";

const Home = ()=>{
    return(
        <div>
            <MatchGames />
        </div>
    )

}

export default Home;